<template>
  <section class="scroll-container">
    <div ref="scrollCon" class="scroll-con" v-if="list.length > 0">
      <!--列表展示-->
      <slot></slot>

      <!--加载状态-->
      <div class="load-state">
        <div class="finish" v-if="finish">
          <slot name="noMore"><span>没有更多了~</span></slot>
        </div>
        <div class="more" v-else-if="!finish && loading">
          <slot name="loading"><span>加载中</span></slot>
        </div>
      </div>
    </div>

    <!--整页无数据时显示-->
    <div class="no-data" v-else>
      <slot name="noData">
        <img src="../../assets/images/no-comment.png" alt="壹心理直播">
        <slot name="noDataTip">
          <p>当前暂无直播</p>
        </slot>
      </slot>
    </div>
  </section>
</template>

<script>
  import { pagination } from 'mixins'

  export default {
    name: "LoadMore",
    props: {
      loadmore: {
        type: Function,
        default() {
          return Promise.resolve()
        }
      },
      ban: Boolean, // 是否禁止触发scroll的回调事件
      list: {
        type: Array,
        default: () => []
      },
      backReflash: {
        type: Boolean,
        default: true
      }
    },
    mixins: [pagination],
    data() {
      return {
        loading: false,
        finish: false,
        $handleScrollBind: null
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.uninstall()
    },
    methods: {
      init() {
        this._loadMore()
        this.uninstall()
        this.$handleScrollBind = this.handleScroll.bind(this)
        this.$nextTick(() => {
          window.addEventListener('scroll', this.$handleScrollBind)
        })
      },
      handleScroll () {
        if (this.ban) return
        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        let scrollHeight = document.body.scrollHeight
        let clientHeight = document.documentElement.clientHeight
        if (scrollHeight - scrollTop - clientHeight < 50 && !this.loading && !this.finish) {
          this._loadMore()
        }
      },
      _loadMore() {
        if (this.loading || this.ban) return false
        this.loading = true
        this.loadmore({
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }).then((data) => {
          this.totalCount = data.totalCount
          this.totalPage = data.totalPage
          this.pageNo++

          // 关闭正在加载中
          this.loading = false
          const isInsufficient = this.pageSize > data.length
          // 如果没有更多数据，则加载完成
          if ((this.pageNo > data.totalPage || data.length === 0) ||
              isInsufficient
          ) {
            this.finish = true
            return
          }
          // 判断不满一屏时继续加载下一页
          this.$nextTick(() => {
            if (this.$refs.scrollCon && this.$refs.scrollCon.clientHeight <= document.documentElement.clientHeight) {
              this._loadMore()
            }
          })
        })
      },
      reset() {
        this.finish = false
        this.pageNo = 1
        this.init()
      },
      uninstall () {
        if (this.$handleScrollBind) {
          window.removeEventListener('scroll', this.$handleScrollBind)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.scroll-container {
  height: 100%;

  .no-data,
  .finish,
  .more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
  }

  .no-data {
    min-height: 100vh;
    flex-direction: column;

    img {
      width: 330px;
    }

    p {
      margin-top: 30px;
      font-size: 28px;
      color: #6C798C;
      text-align: center;
    }
  }
}
</style>
